import { LangSelector } from '@host/components/LangSelector'
import { MenuBook, SportsEsports } from '@mui/icons-material'
import { Container, IconButton, Stack, Tooltip } from '@mui/material'
import { Header, MenuIcon, Tile } from '@tom-ui/ui'
import { appStore } from '@host/stores/AppStore'
import { authStore, PATHS, useAuth, withAuthenticationRequired } from '@tom-ui/utils'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'

const Profile: FC = withAuthenticationRequired(
  observer(() => {
    const { user, isAuthenticated } = useAuth()
    const { t } = useTranslate()
    const navigate = useNavigate()

    return (
      <>
        <Helmet>
          <title>Profile</title>
        </Helmet>
        {isAuthenticated && (
          <>
            <Header
              leftRenderOption={
                appStore.isMobile && (
                  <Tooltip title={t('openMenu', 'Open menu')}>
                    <IconButton onClick={() => appStore.toggleMenu(true)}>
                      <MenuIcon />
                    </IconButton>
                  </Tooltip>
                )
              }
              title={t('profile', 'Profile')}
              rightRenderOption={
                authStore.isSuperUser && (
                  <Stack direction='row' gap={1}>
                    <Tooltip title={t('documentationStatus', 'Documentation Status')}>
                      <IconButton onClick={() => navigate(PATHS.documentationStatus.url)}>
                        <MenuBook />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={t('arcade', 'Arcade')}>
                      <IconButton onClick={() => navigate(PATHS.arcade.url)}>
                        <SportsEsports />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                )
              }
            />
            <Container sx={{ paddingY: 2 }}>
              <Stack gap={4}>
                <Stack flexDirection='row' gap={8}>
                  <Tile label={t('name', 'Name')} value={user?.given_name ?? ' - '} />
                  <Tile label={t('email', 'Email')} value={user?.email ?? ' - '} />
                  <Tile
                    label={t('phoneNumber', 'Phone number')}
                    value={user?.phone_number ?? ' - '}
                  />
                </Stack>
                <LangSelector />
              </Stack>
            </Container>
          </>
        )}
      </>
    )
  }),
)

export default Profile
